import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";
import { cn } from "../../lib/utils";

function SliderComponent({ className, thumbValue = 0, thumbColor = "bg-gray-400", endText, ...props }, ref) {
  const showEndText = props?.value[0] === props?.max && endText;

  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full touch-none select-none items-center", className)}
      {...props}
    >
      <SliderPrimitive.Track className='relative h-[0.875rem] w-full grow overflow-hidden rounded-full bg-gray-300/50'>
        <SliderPrimitive.Range className='absolute h-full bg-gray-500' />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          "h-[26px] px-2 py-1 rounded-lg justify-start items-center gap-2.5 inline-flex cursor-pointer shadow transition-colors focus-visible:outline-none focus-visible:ring-0 disabled:pointer-events-none disabled:opacity-50",
          thumbColor
        )}
        aria-label='Slider'
      >
        <div className="text-center text-white text-xs font-bold font-['Roboto'] text-nowrap">
          {showEndText ? endText : null}
          {!showEndText &&
            (thumbValue !== null
              ? thumbValue.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL"
                })
              : "0")}
        </div>
      </SliderPrimitive.Thumb>
    </SliderPrimitive.Root>
  );
}

const Slider = React.forwardRef(SliderComponent);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
